import { render, staticRenderFns } from "./phoneApp.vue?vue&type=template&id=19e74bb2&scoped=true&"
import script from "./phoneApp.vue?vue&type=script&lang=js&"
export * from "./phoneApp.vue?vue&type=script&lang=js&"
import style0 from "./phoneApp.vue?vue&type=style&index=0&id=19e74bb2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e74bb2",
  null
  
)

export default component.exports